import { CardFieldTemplateDTO, CardFieldValidationTemplateDTO, InitializeSessionRequestDTO } from "../interfaces/pay-dto";
import { InitializePaymentSession } from "../../src/models/payment/interfaces/payment";
import {
  FREEDOMPAY_GATEWAY_ID,
  PAY_TYPE_APPLE,
  PAY_TYPE_CREDIT_DEBIT,
  PAY_TYPE_GOOGLE,
  STORED_CREDIT_CARD
} from "../../app-constants";

const mapPayPaymentType = (internalPaymentType?: string): string => {
  switch (internalPaymentType) {
    case PAY_TYPE_APPLE:
      return "ApplePay";

    case PAY_TYPE_GOOGLE:
      return "GooglePay";

    case STORED_CREDIT_CARD:
      return "CardOnFile";

    case PAY_TYPE_CREDIT_DEBIT:
    default:
      return "CreditCard";
  }
};

const mapFreedomPayHpcCreditCard = (styles: string) => {
  const cardNumber: CardFieldTemplateDTO = {
    label_type: 1,
    placeholder_type: 3
  };

  const expDate: CardFieldValidationTemplateDTO = {
    label_type: 1,
    placeholder_type: 2,
    validation_type: 1
  };

  const postalCode: CardFieldValidationTemplateDTO = {
    label_type: 1,
    placeholder_type: 3,
    validation_type: 0 // if this is 1, it will not render the field. More info below from docs"
    // Use this (1) to make “PostalCode” not appear at all on the Payment Page. If not added, it defaults to Required.
  };

  const securityCode: CardFieldTemplateDTO = {
    label_type: 1,
    placeholder_type: 4
  };

  return {
    credit_card: {
      button_type: 4,
      card_icon_display_type: 1,
      card_number: cardNumber,
      culture_code: "en-US",
      expiration_date: expDate,
      postal_code: postalCode,
      security_code: securityCode,
      styles: styles,
      validation_message_type: 2,
      workflow_type: 1
    }
  };
};

const mapFreedomPayHpcApplePay = (styles: string, amount: string) => {
  return {
    apple_pay: {
      button_type: 1,
      button_color: 1,
      total_price: amount,
      styles: styles,
      response_type: 1,
      auto_finalize_payment: false
    }
  };
};

const mapFreedomPayHpcPayType = (initializeSession: InitializePaymentSession): object => {
  const styles: string = initializeSession.styles || "";

  switch (initializeSession.payType) {
    case PAY_TYPE_APPLE:
      return mapFreedomPayHpcApplePay(styles, initializeSession.amount + "");

    case PAY_TYPE_CREDIT_DEBIT:
    default:
      return mapFreedomPayHpcCreditCard(styles);
  }
};

export const mapInitializePaymentSessionToDTO = (initializeSession: InitializePaymentSession): InitializeSessionRequestDTO => {
  const mappedRequest: InitializeSessionRequestDTO = {
    terminal_id: initializeSession.terminalId + "",
    amount: initializeSession.amount + "",
    total_price: initializeSession.amount + "",
    payment_type: mapPayPaymentType(initializeSession.payType),
    gateway: initializeSession.gatewayId + ""
  };

  if (initializeSession.gatewayId === FREEDOMPAY_GATEWAY_ID) {
    mappedRequest.freedom_pay_hpc = mapFreedomPayHpcPayType(initializeSession);
  }

  return mappedRequest;
};
